const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="o-rhythm">
  <p class="u-text-big">
    This paragraph has <b>u-text-big</b> applied. It starts the same size as the body copy, but gradually grows larger with the viewport size.
  </p>
  <p>
    This paragraph is the default font size. There are no text utilities applied to it.
  </p>
  <p class="u-text-small">
    This paragraph has <b>u-text-small</b> applied. It will always be one modular scale step smaller than the default font size, except it will never reduce below 16 pixels to maintain readability.
  </p>
</div>
`);
            }

            getTemplateName() {
                return `989c641a4181b7d18f5e4a3cee465286663cd8eff66fd77954d2c0a18683020f`;
            }

            getSourceContext() {
                return new this.Source(``, `989c641a4181b7d18f5e4a3cee465286663cd8eff66fd77954d2c0a18683020f`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '989c641a4181b7d18f5e4a3cee465286663cd8eff66fd77954d2c0a18683020f');

let template = env.loadTemplate('989c641a4181b7d18f5e4a3cee465286663cd8eff66fd77954d2c0a18683020f');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/utilities/text/demo/size.twig", args: context }
     );
     return rendered;;
};